import React, {Component} from 'react';
import {connect} from 'react-redux';
import './DisplayQuestionImage.scss';
import {Storage} from '../../../shared/services/aws';

class DisplayQuestionImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        questionPhotoUrl: null
    };
  }

  componentDidMount() {
    if (this.props.questionPhoto) {
      this.getS3Link(this.props.questionPhoto);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.questionPhoto) {
      this.getS3Link(nextProps.questionPhoto);
    }
  }

  getS3Link(imageUrl) {
    if (imageUrl) {
      Storage.get(imageUrl)
      .then(result => {
        this.setState({
            questionPhotoUrl: result
        });
      })
      .catch((err) => {
        console.log(err);
      });
    }
    else {
      this.setState({
        questionPhotoUrl: null
      });
    }
  }

  render() {
    return (
        <div className="display-question-photo">
            <img src={this.state.questionPhotoUrl} />
        </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
  };
};

export default connect(mapStateToProps)(DisplayQuestionImage);
